import type { AppearanceModule } from '@setplex/tria-api'
import type { JSX } from 'react'

import { useStoreMap, useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { versioning } from '~/core/flags'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { resolveModuleDocumentTitle } from '../lib'
import { $modules } from '../model'

type ModuleAppTitleProps = {
  identifier: string
  fallbackKey: string
}

export function ModuleAppTitle({
  identifier,
  fallbackKey,
}: ModuleAppTitleProps): JSX.Element {
  const contentLocalizationEnabled = useUnit(
    versioning.$isContentLocalizationEnabled
  )
  const mod = useStoreMap({
    store: $modules,
    keys: [identifier],
    fn: (modules, [id]): AppearanceModule | null =>
      modules?.find((m) => m.identifier === id) ?? null,
  })
  const { t } = useTranslation()
  const title = resolveModuleDocumentTitle(
    mod,
    t,
    contentLocalizationEnabled,
    identifier,
    fallbackKey
  )

  return <AppTitle>{title}</AppTitle>
}

ModuleAppTitle.displayName = 'ModuleAppTitle'
